import "core-js/modules/web.dom-collections.iterator.js";
import { reaction } from "mobx";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import styled from "styled-components";
import Cesium from "../../../Models/Cesium";
import PositionRightOfWorkbench from "../../Workbench/PositionRightOfWorkbench";
import DropPedestrianToGround from "./DropPedestrianToGround";
import MiniMap, { getViewFromScene } from "./MiniMap";
import MovementControls from "./MovementControls";
import { MeasureTool } from "../../Map/MapNavigation/Items";

// The desired camera height measured from the surface in metres
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const PEDESTRIAN_HEIGHT = 1.7;

// Maximum up/down look angle in degrees
export const MAX_VERTICAL_LOOK_ANGLE = 40;
export const PEDESTRIAN_MODE_ID = "pedestrian-mode";
const PedestrianMode = observer(props => {
  const {
    viewState
  } = props;
  const cesium = viewState.terria.currentViewer;
  const [isDropped, setIsDropped] = useState(false);
  const [view, setView] = useState();
  const onDropCancelled = () => viewState.closeTool();
  //if viewer is not cesium close tool.
  if (!(cesium instanceof Cesium)) {
    viewState.closeTool();
    return null;
  }
  const updateView = () => setView(getViewFromScene(cesium.scene));
  useEffect(() => {
    var _viewState$terria$map;
    const item = (_viewState$terria$map = viewState.terria.mapNavigationModel.findItem(MeasureTool.id)) === null || _viewState$terria$map === void 0 ? void 0 : _viewState$terria$map.controller;
    if (item && item.active) {
      item.deactivate();
    }
    viewState.terria.mapNavigationModel.disable(MeasureTool.id);
    return () => {
      viewState.terria.mapNavigationModel.enable(MeasureTool.id);
    };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);
  useEffect(function closeOnZoomTo() {
    return reaction(() => cesium.isMapZooming, isMapZooming => {
      if (isMapZooming) viewState.closeTool();
    });
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!isDropped && /*#__PURE__*/_jsx(DropPedestrianToGround, {
      cesium: cesium,
      afterDrop: () => setIsDropped(true),
      onDropCancelled: onDropCancelled,
      pedestrianHeight: PEDESTRIAN_HEIGHT
    }), isDropped && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ControlsContainer, {
        viewState: viewState,
        children: /*#__PURE__*/_jsx(MovementControls, {
          cesium: cesium,
          onMove: updateView,
          pedestrianHeight: PEDESTRIAN_HEIGHT,
          maxVerticalLookAngle: MAX_VERTICAL_LOOK_ANGLE
        })
      }), /*#__PURE__*/_jsx(MiniMapContainer, {
        viewState: viewState,
        children: /*#__PURE__*/_jsx(MiniMap, {
          terria: viewState.terria,
          baseMap: viewState.terria.mainViewer.baseMap,
          view: view || getViewFromScene(cesium.scene)
        })
      })]
    })]
  });
});
const ControlsContainer = styled(PositionRightOfWorkbench).withConfig({
  displayName: "PedestrianMode__ControlsContainer",
  componentId: "sc-fw5onw-0"
})(["width:140px;top:unset;left:0;bottom:300px;"]);
const MiniMapContainer = styled(PositionRightOfWorkbench).withConfig({
  displayName: "PedestrianMode__MiniMapContainer",
  componentId: "sc-fw5onw-1"
})(["width:140px;height:180px;top:unset;left:0;bottom:100px;"]);
export default PedestrianMode;